if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

let bodyForm = document.querySelector( "body" )
if( bodyForm.classList.contains( "54thirtyRooftop" ) ){

    //bodyForm.querySelector( ".email-signup .gdpr-wrap" ).remove();
    let fields_wrap = bodyForm.querySelector( ".email-signup .fields-wrap" )

    let text = document.createElement( "div" );
    text.innerHTML = "**By submitting this request to join the email and/or SMS club, I certify that I have read the terms and conditions provided (<a href='https://www.54thirty.com/privacy-policy' target='_blank'>https://www.54thirty.com/privacy-policy</a>) and I agree to receive marketing emails and autodialed marketing messages from 54thirty Rooftop at the email address and phone number I have provided. I understand that no purchase is necessary. For email, you may choose to unsubscribe at any time by clicking on the unsubscribe link included in all emails. For SMS, message and data rates apply. You can opt out or terminate the mobile service anytime by texting STOP to (833)-988-3198. For help, Text HELP to (833)-988-3198. Message frequency may vary. When you click the Submit button below, we will send a text message to your phone. To confirm that you received the message and that you want to receive offers and information, reply YES to confirm your registration."
    text.style.color = "#FFF"
    text.style.fontSize = "10px"

    fields_wrap.appendChild( text );
    text.classList.add( "input" )

    let email_signup_velocity_sms = document.querySelector( "#email-signup [name*=sms]" )
    email_signup_velocity_sms.addEventListener( "click", (e) => {
        if( e.target.checked ){
            document.querySelector( "#email-signup [name=SMSOptin]" ).value = "TRUE"
        }else{
            document.querySelector( "#email-signup [name=SMSOptin]" ).value = "FALSE"
        }
    } )

}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });
    $('.reviews').slick({
        fade:true,
        accessibility: true,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows:false,
                dots: true,
                adaptiveHeight:true
              }
            }
        ]
    })

    setTimeout(()=> {
        const elementDelete = document.querySelector('.ot-dtp-picker.wide>h1');
        elementDelete ? elementDelete.remove() : '';
    }, 3000);
})();